import mergeSpeakers from './mergeSpeakers';
import formatTranscriptForCopy from './formatTranscriptForCopy';
import copyTextToClipboard from '../../../helpers/copyTextToClipboard';

export default function copyTranscript({ transcript, isSpeakers, isTimestamps }) {
  const merged = mergeSpeakers(transcript);
  const formatted = formatTranscriptForCopy({ transcript: merged, isSpeakers, isTimestamps });
  copyTextToClipboard(formatted);
}
